import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Project } from 'src/app/_models';

@Component({
    standalone: false,
  selector: 'integration-apps-oscal-poam',
  templateUrl: './integration-apps-oscal-poam.component.html',
  styleUrls: ['./integration-apps-oscal-poam.component.css'],
})
export class IntegrationAppsOscalPoamComponent implements OnInit {
  @Input() projects: Project[];
  @Input() settings: any;
  @Input() settingsForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'project',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'isRlink',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'dummyRlink',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }
}
